(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactBlock = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var updateFloat = function updateFloat(field) {
  var wrapper = field.closest('.form-float');
  if (!wrapper) return;
  wrapper.classList.toggle('--float-active', field.value.length > 0 || document.activeElement === field);
};
var initFloatingLabels = function initFloatingLabels() {
  var fields = document.querySelectorAll('.form-float input, .form-float textarea');
  var _iterator = _createForOfIteratorHelper(fields),
    _step;
  try {
    var _loop = function _loop() {
      var field = _step.value;
      updateFloat(field);
      field.addEventListener('focus', function () {
        return updateFloat(field);
      });
      field.addEventListener('blur', function () {
        return updateFloat(field);
      });
      field.addEventListener('input', function () {
        return updateFloat(field);
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var contactBlock = exports.contactBlock = function contactBlock() {
  initFloatingLabels();
  document.addEventListener('wpcf7mailsent', initFloatingLabels);
  document.addEventListener('wpcf7invalid', initFloatingLabels);
};

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollTextBlock = scrollTextBlock;
function scrollTextBlock() {
  document.querySelectorAll('.scroll-text__wrapper.no-scroll').forEach(function (wrapper) {
    wrapper.addEventListener('scroll', function () {
      wrapper.classList.remove('no-scroll');
    }, {
      once: true
    });
  });
}

},{}],3:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncCartCount = exports.pushCartEvent = exports.initCartObserver = exports.cartInit = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var countInfo = document.querySelector('.--count-cart');
var removeButtonsSlideCart = [];
var changeQtySlieCart = [];
var alertInfo;
var syncCartCount = exports.syncCartCount = function syncCartCount() {
  var formData = new FormData();
  formData.append('action', 'apiGetCartCount');
  formData.append('nonce', dataTheme.nonce);
  fetch(dataTheme.ajaxUrl, {
    method: 'POST',
    body: formData
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (!data.success) return;
    updateCountBasket(data.success.cartCount);
    if (data.success.html) {
      var slideCart = document.querySelector('.--slide-cart');
      var bgOverflow = document.querySelector('.--slide-cart-overflow');
      var body = slideCart ? slideCart.querySelector('.--slide-cart-body') : null;
      if (body) {
        body.innerHTML = data.success.html;
        updateActionsFromSlideCart(slideCart, body, bgOverflow);
      }
    }
  }).catch(function () {});
};
var cartInit = exports.cartInit = function cartInit() {
  var slideCart = document.querySelector('.--slide-cart');
  var bgOverflow = document.querySelector('.--slide-cart-overflow');
  if (!slideCart || !bgOverflow) {
    return;
  }
  var bodySlideCart = slideCart.querySelector('.--slide-cart-body');
  var togglers = document.querySelectorAll('.--toggler-slide-cart');
  changeQtySlieCart = bodySlideCart.querySelectorAll('.--qty-slide-cart');
  ;
  var _iterator = _createForOfIteratorHelper(togglers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var toggler = _step.value;
      if (bodySlideCart.contains(toggler)) {
        continue;
      }
      toggler.addEventListener('click', function (e) {
        e.preventDefault();
        toggleSlideCart();
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  bgOverflow.addEventListener('click', function (e) {
    e.preventDefault();
    toggleSlideCart();
  });
  var toggleSlideCart = function toggleSlideCart() {
    document.body.classList.toggle('overflow-hidden');
    bgOverflow.classList.toggle('active');
    slideCart.classList.toggle('active');
  };
  addToCart(slideCart, bodySlideCart, bgOverflow);
  updateActionsFromSlideCart(slideCart, bodySlideCart, bgOverflow);
  alertInfo = slideCart.querySelector('.--slide-cart-alert');
};
var addToCart = function addToCart(slideCart, bodySlideCart, bgOverflow) {
  var form = document.querySelector('.--add-to-cart-form');
  if (!form) {
    return;
  }
  var button = form.querySelector('.--add-to-cart');
  if (!button) {
    return;
  }
  button.addEventListener('click', function (e) {
    e.preventDefault();
    form.classList.add('loading');
    var formData = new FormData(form);
    formData.append('action', 'apiAddToCart');
    formData.append('nonce', dataTheme.nonce);
    fetch(dataTheme.ajaxUrl, {
      method: 'POST',
      body: formData
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      form.classList.remove('loading');
      document.body.classList.add('overflow-hidden');
      slideCart.classList.add('active');
      bgOverflow.classList.add('active');
      if (data.success) {
        var _form$querySelector;
        updateCountBasket(data.success.cartCount);
        bodySlideCart.innerHTML = data.success.html;
        updateActionsFromSlideCart(slideCart, bodySlideCart, bgOverflow);
        pushCartEvent('add_to_cart', {
          item_id: form.dataset.gtmSku || '',
          item_name: form.dataset.gtmName || '',
          price: parseFloat(form.dataset.gtmPrice || 0),
          quantity: parseInt(((_form$querySelector = form.querySelector('[name=quantity]')) === null || _form$querySelector === void 0 ? void 0 : _form$querySelector.value) || 1, 10)
        });
        return;
      }
      if (data.error) {
        alertCart(alertInfo, data.error);
      }
    }).catch(function (error) {
      console.log(error);
    });
  });
};
var pushCartEvent = exports.pushCartEvent = function pushCartEvent(eventName, item) {
  if (!window.dataLayer || !item.item_name) return;
  window.dataLayer.push({
    event: eventName,
    ecommerce: {
      currency: window.gtm4wp_currency || 'PLN',
      value: +(item.price * item.quantity).toFixed(2),
      items: [{
        item_id: item.item_id || '',
        item_name: item.item_name,
        price: item.price,
        quantity: item.quantity
      }]
    }
  });
};
var updateCountBasket = function updateCountBasket(count) {
  countInfo.textContent = count;
  if (count > 0) {
    countInfo.classList.add('active');
    return;
  }
  countInfo.classList.remove('active');
};
var updateActionsFromSlideCart = function updateActionsFromSlideCart(slideCart, bodySlideCart, bgOverflow) {
  var togglerInCart = bodySlideCart.querySelector('.--toggler-slide-cart');
  if (togglerInCart) {
    togglerInCart.addEventListener('click', function (e) {
      e.preventDefault();
      document.body.classList.toggle('overflow-hidden');
      bgOverflow.classList.toggle('active');
      slideCart.classList.toggle('active');
    });
  }
  removeButtonsSlideCart = bodySlideCart.querySelectorAll('.--remove-slide-cart');
  if (removeButtonsSlideCart.length) {
    var _iterator2 = _createForOfIteratorHelper(removeButtonsSlideCart),
      _step2;
    try {
      var _loop = function _loop() {
        var element = _step2.value;
        element.addEventListener('click', function (e) {
          e.preventDefault();
          var key = element.dataset.key;
          var gtmData = {
            item_id: element.dataset.gtmSku || '',
            item_name: element.dataset.gtmName || '',
            price: parseFloat(element.dataset.gtmPrice || 0),
            quantity: parseInt(element.dataset.gtmQty || 1, 10)
          };
          removeFromSlideCart(slideCart, bodySlideCart, bgOverflow, key, gtmData);
        });
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  changeQtySlieCart = bodySlideCart.querySelectorAll('.--qty-slide-cart');
  if (changeQtySlieCart.length) {
    var _iterator3 = _createForOfIteratorHelper(changeQtySlieCart),
      _step3;
    try {
      var _loop2 = function _loop2() {
        var element = _step3.value;
        element.addEventListener('change', function (e) {
          e.preventDefault();
          var key = element.dataset.key;
          var qty = element.value;
          if (qty === 'more') {
            var wrapper = element.closest('.slide-cart__item-actions');
            var input = wrapper.querySelector('.--qty-slide-cart-input');
            element.style.display = 'none';
            input.style.display = '';
            input.focus();
            return;
          }
          var gtmData = {
            item_id: element.dataset.gtmSku || '',
            item_name: element.dataset.gtmName || '',
            price: parseFloat(element.dataset.gtmPrice || 0),
            oldQty: parseInt(element.dataset.gtmQty || 1, 10),
            newQty: parseInt(qty, 10)
          };
          updateQtySlideCart(slideCart, bodySlideCart, bgOverflow, key, qty, gtmData);
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  var qtyInputs = bodySlideCart.querySelectorAll('.--qty-slide-cart-input');
  if (qtyInputs.length) {
    var _iterator4 = _createForOfIteratorHelper(qtyInputs),
      _step4;
    try {
      var _loop3 = function _loop3() {
        var input = _step4.value;
        input.addEventListener('change', function (e) {
          e.preventDefault();
          var key = input.dataset.key;
          var qty = Math.max(parseInt(input.value, 10) || 10, 1);
          input.value = qty;
          var gtmData = {
            item_id: input.dataset.gtmSku || '',
            item_name: input.dataset.gtmName || '',
            price: parseFloat(input.dataset.gtmPrice || 0),
            oldQty: parseInt(input.dataset.gtmQty || 1, 10),
            newQty: qty
          };
          updateQtySlideCart(slideCart, bodySlideCart, bgOverflow, key, qty, gtmData);
        });
      };
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        _loop3();
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
};
var removeFromSlideCart = function removeFromSlideCart(slideCart, bodySlideCart, bgOverflow, key, gtmData) {
  slideCart.classList.add('loading');
  var formData = new FormData();
  formData.append('action', 'apiRemoveFromSlideCart');
  formData.append('key', key);
  formData.append('nonce', dataTheme.nonce);
  fetch(dataTheme.ajaxUrl, {
    method: 'POST',
    body: formData
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    slideCart.classList.remove('loading');
    if (data.success) {
      updateCountBasket(data.success.cartCount);
      bodySlideCart.innerHTML = data.success.html;
      updateActionsFromSlideCart(slideCart, bodySlideCart, bgOverflow);
      if (gtmData) pushCartEvent('remove_from_cart', gtmData);
      return;
    }
    if (data.error) {
      alertCart(alertInfo, data.error);
    }
  }).catch(function (error) {
    console.log(error);
  });
};
var updateQtySlideCart = function updateQtySlideCart(slideCart, bodySlideCart, bgOverflow, key, qty, gtmData) {
  slideCart.classList.add('loading');
  var formData = new FormData();
  formData.append('action', 'apiUpdateSlideCartQty');
  formData.append('key', key);
  formData.append('qty', qty);
  formData.append('nonce', dataTheme.nonce);
  fetch(dataTheme.ajaxUrl, {
    method: 'POST',
    body: formData
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    slideCart.classList.remove('loading');
    if (data.success) {
      updateCountBasket(data.success.cartCount);
      bodySlideCart.innerHTML = data.success.html;
      updateActionsFromSlideCart(slideCart, bodySlideCart, bgOverflow);
      if (gtmData) {
        var delta = gtmData.newQty - gtmData.oldQty;
        if (delta > 0) {
          pushCartEvent('add_to_cart', _objectSpread(_objectSpread({}, gtmData), {}, {
            quantity: delta
          }));
        } else if (delta < 0) {
          pushCartEvent('remove_from_cart', _objectSpread(_objectSpread({}, gtmData), {}, {
            quantity: Math.abs(delta)
          }));
        }
      }
      return;
    }
    if (data.error) {
      alertCart(alertInfo, data.error);
    }
  }).catch(function (error) {
    console.log(error);
  });
};
var alertCart = function alertCart(wrapper, alert) {
  wrapper.textContent = alert;
  wrapper.classList.add('active');
  setTimeout(function () {
    wrapper.classList.remove('active');
  }, 6000);
};
var debounce = function debounce(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      return fn.apply(void 0, args);
    }, delay);
  };
};
var updateCounter = function updateCounter() {
  var qtys = _toConsumableArray(document.querySelectorAll('.wc-block-components-quantity-selector__input'));
  var total = qtys.reduce(function (sum, el) {
    return sum + (parseInt(el.value || 0, 10) || 0);
  }, 0);
  if (countInfo) {
    updateCountBasket(total);
  }
};
var debouncedUpdateCounter = debounce(updateCounter, 1000);
var initCartObserver = exports.initCartObserver = function initCartObserver() {
  var cartContainer = document.querySelector('.wc-block-cart-items');
  if (!cartContainer) {
    return;
  }
  var observer = new MutationObserver(function () {
    debouncedUpdateCounter();
  });
  observer.observe(cartContainer, {
    childList: true,
    subtree: true,
    attributes: true
  });
};

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = exports.getCookie = void 0;
var getCookie = exports.getCookie = function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  return null;
};
var setCookie = exports.setCookie = function setCookie(name, value) {
  var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = "".concat(name, "=").concat(encodeURIComponent(JSON.stringify(value)), "; expires=").concat(date.toUTCString(), "; path=/");
};

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initLangSwitcher = void 0;
var LANGS = ['pl', 'en', 'de', 'da'];
var getCurrentLang = function getCurrentLang() {
  var match = document.cookie.match(/googtrans=\/[a-z]+\/([a-z]+)/);
  return match && LANGS.includes(match[1]) ? match[1] : 'pl';
};
var setLang = function setLang(lang) {
  var hostname = window.location.hostname;
  var clear = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
  document.cookie = clear;
  document.cookie = clear + '; domain=' + hostname;
  document.cookie = clear + '; domain=.' + hostname;
  if (lang !== 'pl') {
    var val = '/pl/' + lang;
    document.cookie = 'googtrans=' + val + '; path=/';
    document.cookie = 'googtrans=' + val + '; path=/; domain=' + hostname;
    document.cookie = 'googtrans=' + val + '; path=/; domain=.' + hostname;
  }
  var url = new URL(window.location.href);
  url.searchParams.delete('_gt');
  window.location.replace(url.toString());
};

// Ładuje skrypt GT dynamicznie — tylko gdy język != PL
var loadGoogleTranslate = function loadGoogleTranslate() {
  var script = document.createElement('script');
  script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
  script.async = true;
  document.head.appendChild(script);
};
var updateCurrentLabels = function updateCurrentLabels(lang) {
  var label = lang.toUpperCase();
  document.querySelectorAll('.lang-switcher__current').forEach(function (el) {
    el.textContent = label;
  });
};
var markActiveItem = function markActiveItem(lang) {
  document.querySelectorAll('.lang-switcher__item').forEach(function (btn) {
    btn.classList.toggle('active', btn.dataset.lang === lang);
  });
};
var initLangSwitcher = exports.initLangSwitcher = function initLangSwitcher() {
  var currentLang = getCurrentLang();
  updateCurrentLabels(currentLang);
  markActiveItem(currentLang);

  // GT ładuje się tylko gdy strona ma być przetłumaczona
  if (currentLang !== 'pl') {
    loadGoogleTranslate();
  }
  var desktopSwitcher = document.querySelector('.lang-switcher--desktop');
  if (desktopSwitcher) {
    document.addEventListener('click', function (e) {
      if (!desktopSwitcher.contains(e.target)) {
        var _desktopSwitcher$quer;
        (_desktopSwitcher$quer = desktopSwitcher.querySelector('.lang-switcher__toggle')) === null || _desktopSwitcher$quer === void 0 || _desktopSwitcher$quer.setAttribute('aria-expanded', 'false');
      }
    });
  }
  var mobileSwitcher = document.querySelector('.lang-switcher--mobile');
  if (mobileSwitcher) {
    var toggle = mobileSwitcher.querySelector('.lang-switcher__toggle-mobile');
    var list = mobileSwitcher.querySelector('.lang-switcher__list');
    if (toggle && list) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        list.classList.toggle('active', !expanded);
      });
    }
  }
  document.querySelectorAll('.lang-switcher__item').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('active')) return;
      setLang(btn.dataset.lang);
    });
  });
};

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuUnderline = void 0;
var _variables = require("./variables");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var menuUnderline = exports.menuUnderline = function menuUnderline(header) {
  if (_variables.isMobile) {
    return;
  }
  var menu = header.querySelector('.site-header__nav');
  if (!menu) {
    return;
  }
  var items = menu.querySelectorAll('.site-header__menu-link');
  var underline = header.querySelector('.menu__underline');
  var _iterator = _createForOfIteratorHelper(items),
    _step;
  try {
    var _loop = function _loop() {
      var item = _step.value;
      item.addEventListener('mouseenter', function () {
        var itemRect = item.getBoundingClientRect();
        var menuRect = menu.getBoundingClientRect();
        var left = itemRect.left - menuRect.left;
        var width = itemRect.width;
        underline.style.width = width + 'px';
        underline.style.transform = "translateX(".concat(left, "px)");
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  menu.addEventListener('mouseleave', function () {
    var currentLeft = underline.getBoundingClientRect().left;
    var menuLeft = menu.getBoundingClientRect().left;
    var currentWidth = underline.offsetWidth;
    var rightEdge = currentLeft - menuLeft + currentWidth;
    underline.style.transform = "translateX(".concat(rightEdge, "px)");
    underline.style.width = 0;
  });
};

},{"./variables":13}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postNav = void 0;
var postNav = exports.postNav = function postNav() {
  var contentContainer = document.querySelector('.--post-content');
  var wrapper = document.querySelector('.--post-nav');
  if (!contentContainer || !wrapper) return;
  var headings = contentContainer.querySelectorAll('h2, h3');
  if (!headings.length) {
    return;
  }
  headings.forEach(function (heading, index) {
    if (!heading.id) {
      heading.id = "heading-".concat(index + 1);
    }
  });
  var list = document.createElement('ol');
  list.className = 'post__nav-list no-style';
  headings.forEach(function (heading) {
    var li = document.createElement('li');
    li.className = "post__nav-item level-".concat(heading.tagName.toLowerCase());
    var a = document.createElement('a');
    a.href = "#".concat(heading.id);
    a.textContent = heading.textContent;
    a.className = 'post__nav-link';
    li.appendChild(a);
    list.appendChild(li);
  });
  wrapper.appendChild(list);
  wrapper.style.display = '';
};

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initPostShare = void 0;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var initPostShare = exports.initPostShare = function initPostShare() {
  var copyBtn = document.querySelector('.post-share__btn--copy');
  if (!copyBtn) return;
  copyBtn.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var label, original, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return navigator.clipboard.writeText(window.location.href);
        case 1:
          label = copyBtn.querySelector('.post-share__btn-label');
          original = label.textContent;
          copyBtn.classList.add('--copied');
          label.textContent = copyBtn.dataset.copied;
          setTimeout(function () {
            copyBtn.classList.remove('--copied');
            label.textContent = original;
          }, 2000);
          _context.n = 3;
          break;
        case 2:
          _context.p = 2;
          _t = _context.v;
        case 3:
          return _context.a(2);
      }
    }, _callee, null, [[0, 2]]);
  })));
};

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.progressBar = void 0;
var progressBar = exports.progressBar = function progressBar() {
  var bar = document.querySelector('.site-header__bottom-progress');
  if (!bar) return;
  var updateProgress = function updateProgress() {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var progress = docHeight > 0 ? scrollTop / docHeight * 100 : 0;
    bar.style.width = "".concat(progress, "%");
  };
  window.addEventListener('scroll', updateProgress, {
    passive: true
  });
  updateProgress();
};

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rememberSearch = exports.initSearch = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var recentKey = 'ferrion_recent_searches';
var recentLimit = 6;
var readRecent = function readRecent() {
  try {
    var value = JSON.parse(window.localStorage.getItem(recentKey) || '[]');
    return Array.isArray(value) ? value.filter(function (item) {
      return typeof item === 'string';
    }) : [];
  } catch (error) {
    return [];
  }
};
var writeRecent = function writeRecent(items) {
  try {
    window.localStorage.setItem(recentKey, JSON.stringify(items.slice(0, recentLimit)));
  } catch (error) {
    return;
  }
};
var rememberSearch = exports.rememberSearch = function rememberSearch(phrase) {
  var value = (phrase || '').trim();
  if (value.length < 2) {
    return;
  }
  var lower = value.toLowerCase();
  writeRecent([value].concat(_toConsumableArray(readRecent().filter(function (item) {
    return item.toLowerCase() !== lower;
  }))));
};
var initSearch = exports.initSearch = function initSearch() {
  var searchWrapper = document.querySelector('.--search-wrapper');
  var bgOverflow = document.querySelector('.--search-overflow');
  if (!searchWrapper || !bgOverflow) {
    return;
  }
  var form = searchWrapper.querySelector('.--search-form');
  var input = searchWrapper.querySelector('.--search-input');
  var result = searchWrapper.querySelector('.--search-result');
  if (!form || !input || !result) {
    return;
  }
  var togglers = document.querySelectorAll('.--toggler-search');
  var info = searchWrapper.querySelector('.search__field-info');
  var start = searchWrapper.querySelector('.--search-start');
  var recent = searchWrapper.querySelector('.--search-recent');
  var recentList = searchWrapper.querySelector('.--search-recent-list');
  var recentClear = searchWrapper.querySelector('.--search-recent-clear');
  var controller = null;
  var timeout = null;
  var lastQuery = '';
  var redirect = null;
  var activeIndex = -1;
  var focusTimeout = null;
  var setInfo = function setInfo(visible) {
    if (info) {
      info.style.visibility = visible ? 'visible' : 'hidden';
    }
  };
  var resetActive = function resetActive() {
    activeIndex = -1;
    var _iterator = _createForOfIteratorHelper(result.querySelectorAll('.is-active')),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        item.classList.remove('is-active');
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  var items = function items() {
    return Array.from(result.querySelectorAll('.--search-item'));
  };
  var setActive = function setActive(index) {
    var list = items();
    list.forEach(function (item, position) {
      return item.classList.toggle('is-active', position === index);
    });
    activeIndex = index;
    if (list[index]) {
      list[index].scrollIntoView({
        block: 'nearest'
      });
    }
  };
  var toggleStart = function toggleStart(visible) {
    if (start) {
      start.hidden = !visible;
    }
  };
  var renderRecent = function renderRecent() {
    if (!recent || !recentList) {
      return;
    }
    var phrases = readRecent();
    recentList.innerHTML = '';
    recent.hidden = phrases.length === 0;
    var _iterator2 = _createForOfIteratorHelper(phrases),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var phrase = _step2.value;
        var item = document.createElement('li');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'search-categories__chip --search-phrase';
        button.dataset.phrase = phrase;
        button.textContent = phrase;
        item.appendChild(button);
        recentList.appendChild(item);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
  var runPhrase = function runPhrase(phrase) {
    input.value = phrase;
    input.dispatchEvent(new Event('input'));
    input.focus();
  };
  var toggleSearch = function toggleSearch() {
    document.body.classList.toggle('overflow-hidden');
    bgOverflow.classList.toggle('active');
    searchWrapper.classList.toggle('active');
    clearTimeout(focusTimeout);
    if (searchWrapper.classList.contains('active')) {
      renderRecent();
      focusTimeout = setTimeout(function () {
        return input.focus();
      }, 300);
      return;
    }
    input.blur();
    input.setAttribute('aria-expanded', 'false');
  };
  var showStart = function showStart() {
    if (controller) {
      controller.abort();
    }
    lastQuery = '';
    redirect = null;
    resetActive();
    result.innerHTML = '';
    result.classList.remove('loading');
    input.setAttribute('aria-expanded', 'false');
    setInfo(true);
    renderRecent();
    toggleStart(true);
  };
  var responses = new Map();
  var useFastEndpoint = true;
  var render = function render(text, payload) {
    lastQuery = text;
    redirect = payload.redirect || null;
    result.innerHTML = payload.html;
    setInfo(false);
    input.setAttribute('aria-expanded', 'true');
    activeIndex = -1;
  };
  var apiSearch = function apiSearch(text) {
    if (controller) {
      controller.abort();
    }
    var key = text.toLowerCase();
    if (responses.has(key)) {
      result.classList.remove('loading');
      render(text, responses.get(key));
      return;
    }
    controller = new AbortController();
    result.classList.add('loading');
    var request = function request(endpoint) {
      var url = new URL(endpoint, window.location.origin);
      url.searchParams.set('action', 'apiSearch');
      url.searchParams.set('text', text);
      return fetch(url.toString(), {
        signal: controller.signal
      }).then(function (response) {
        if (!response.ok) {
          throw new Error(String(response.status));
        }
        return response.json();
      });
    };
    var fast = useFastEndpoint && dataTheme.searchUrl;
    (fast ? request(dataTheme.searchUrl) : request(dataTheme.ajaxUrl)).catch(function (error) {
      if (!fast || error.name === 'AbortError') {
        throw error;
      }
      useFastEndpoint = false;
      return request(dataTheme.ajaxUrl);
    }).then(function (data) {
      if (input.value.trim() !== text) {
        return;
      }
      result.classList.remove('loading');
      if (!data.success) {
        return;
      }
      if (responses.size >= 50) {
        responses.delete(responses.keys().next().value);
      }
      responses.set(key, data.success);
      render(text, data.success);
    }).catch(function (error) {
      if (error.name !== 'AbortError') {
        result.classList.remove('loading');
      }
    });
  };
  var _iterator3 = _createForOfIteratorHelper(togglers),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var toggler = _step3.value;
      toggler.addEventListener('click', function (event) {
        event.preventDefault();
        toggleSearch();
      });
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  bgOverflow.addEventListener('click', function (event) {
    event.preventDefault();
    toggleSearch();
  });
  searchWrapper.addEventListener('click', function (event) {
    var phrase = event.target.closest('.--search-phrase');
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) {
      return;
    }
    if (phrase && searchWrapper.contains(phrase)) {
      event.preventDefault();
      runPhrase(phrase.dataset.phrase || '');
      return;
    }
    if (event.target.closest('.--search-item, .search-categories__chip')) {
      var panel = result.querySelector('.--search-panel');
      rememberSearch(panel && panel.dataset.query ? panel.dataset.query : input.value);
    }
  });
  if (recentClear) {
    recentClear.addEventListener('click', function () {
      writeRecent([]);
      renderRecent();
      input.focus();
    });
  }
  input.addEventListener('input', function () {
    var text = input.value.trim();
    clearTimeout(timeout);
    resetActive();
    if (text.length < 2) {
      showStart();
      return;
    }
    toggleStart(false);
    timeout = setTimeout(function () {
      return apiSearch(text);
    }, 220);
  });
  input.addEventListener('keydown', function (event) {
    var list = items();
    if (event.key === 'ArrowDown' && list.length) {
      event.preventDefault();
      setActive(activeIndex + 1 >= list.length ? 0 : activeIndex + 1);
      return;
    }
    if (event.key === 'ArrowUp' && list.length) {
      event.preventDefault();
      setActive(activeIndex - 1 < 0 ? list.length - 1 : activeIndex - 1);
      return;
    }
    if (event.key === 'Enter' && activeIndex >= 0 && list[activeIndex]) {
      event.preventDefault();
      list[activeIndex].click();
    }
  });
  searchWrapper.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && searchWrapper.classList.contains('active')) {
      event.preventDefault();
      toggleSearch();
    }
  });
  form.addEventListener('submit', function (event) {
    var text = input.value.trim();
    if (text.length < 2) {
      event.preventDefault();
      return;
    }
    rememberSearch(text);
    if (redirect && lastQuery === text) {
      event.preventDefault();
      window.location.href = redirect;
    }
  });
  rememberSearch(new URLSearchParams(window.location.search).get('s'));
};

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slideMenu = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var slideMenu = exports.slideMenu = function slideMenu(header) {
  if (!header) {
    return;
  }
  var menu = document.querySelector('.--slide-menu-wrapper');
  if (!menu) {
    return;
  }
  var toggler = header.querySelector('.--toggler-mobile-menu');
  if (!toggler) {
    return;
  }
  toggler.addEventListener('click', function (e) {
    e.preventDefault();
    document.body.classList.toggle('mobile-menu-active');
    menu.classList.toggle('active');
    toggler.classList.toggle('active');
    toggler.setAttribute('aria-expanded', toggler.classList.contains('active'));
  });
  if (!menu.querySelector('.--open-child-slide-menu')) {
    return;
  }
  var _iterator = _createForOfIteratorHelper(menu.querySelectorAll('.--open-child-slide-menu')),
    _step;
  try {
    var _loop = function _loop() {
      var btn = _step.value;
      btn.addEventListener('click', function () {
        var drop = document.getElementById(btn.getAttribute('aria-controls'));
        if (!drop) return;
        drop.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(menu.querySelectorAll('.--slide-menu-back')),
    _step2;
  try {
    var _loop2 = function _loop2() {
      var btn = _step2.value;
      btn.addEventListener('click', function () {
        var drop = btn.closest('.slide-menu__nav-drop');
        if (!drop) return;
        drop.classList.remove('active');
        var opener = menu.querySelector("[aria-controls=\"".concat(drop.id, "\"]"));
        if (opener) opener.setAttribute('aria-expanded', 'false');
      });
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stickyHeader = void 0;
var stickyHeader = exports.stickyHeader = function stickyHeader() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var lastScroll = 0;
  var handleScroll = function handleScroll() {
    var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
    if (currentScroll > 0) {
      header.classList.add('scroll');
    } else {
      header.classList.remove('scroll');
    }
    if (currentScroll > lastScroll && currentScroll > 200) {
      header.classList.add('scroll-down');
    } else if (currentScroll < lastScroll) {
      header.classList.remove('scroll-down');
    }
    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
  };
  window.addEventListener('scroll', handleScroll);
  handleScroll();
  return header;
};

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobile = void 0;
var isMobile = exports.isMobile = window.innerWidth < 992;

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initWishlistCount = exports.initWishlistButtons = void 0;
var _cookies = require("./cookies");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var countWishlist = document.querySelector('.--count-wishlist');
var getWishlistCookie = function getWishlistCookie(name) {
  var cookie = (0, _cookies.getCookie)(name);
  if (!cookie) {
    return [];
  }
  try {
    var decoded = decodeURIComponent(cookie);
    var parsed = JSON.parse(decoded);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};
var toggleWishlist = function toggleWishlist(productId, btn) {
  var wishlist = getWishlistCookie('wishlist-ferrion');
  var allButtons = document.querySelectorAll(".--toggle-wishlist[data-id=\"".concat(productId, "\"]"));
  var index = wishlist.indexOf(productId);
  if (index === -1) {
    wishlist.push(productId);
    allButtons.forEach(function (b) {
      return b.classList.add('active');
    });
  } else {
    wishlist.splice(index, 1);
    allButtons.forEach(function (b) {
      return b.classList.remove('active');
    });
  }
  (0, _cookies.setCookie)('wishlist-ferrion', wishlist, 365);
  wishlist = getWishlistCookie('wishlist-ferrion');
  if (wishlist.length) {
    countWishlist.textContent = wishlist.length;
    countWishlist.classList.add('active');
    if (btn.classList.contains('--is-page-wishlist')) {
      btn.closest('.loop-product__element').remove();
    }
    return;
  }
  countWishlist.textContent = '0';
  countWishlist.classList.remove('active');
  if (btn.classList.contains('--is-page-wishlist')) {
    window.location.reload();
  }
};
var initWishlistButtons = exports.initWishlistButtons = function initWishlistButtons() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var buttons = container.querySelectorAll('.--toggle-wishlist');
  if (!buttons.length) {
    return;
  }
  var wishlist = getWishlistCookie('wishlist-ferrion');
  var _iterator = _createForOfIteratorHelper(buttons),
    _step;
  try {
    var _loop = function _loop() {
      var button = _step.value;
      var productId = button.dataset.id;
      if (wishlist.includes(productId)) {
        button.classList.add('active');
      }
      button.addEventListener('click', function (e) {
        e.preventDefault();
        toggleWishlist(productId, button);
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var initWishlistCount = exports.initWishlistCount = function initWishlistCount() {
  if (!countWishlist) {
    return;
  }
  var wishlist = getWishlistCookie('wishlist-ferrion');
  if (wishlist.length) {
    countWishlist.textContent = wishlist.length;
    countWishlist.classList.add('active');
  }
};

},{"./cookies":4}],15:[function(require,module,exports){
"use strict";

var _stickyHeader = require("./app/stickyHeader");
var _sldeMenu = require("./app/sldeMenu");
var _postNav = require("./app/postNav");
var _menuUnderline = require("./app/menuUnderline");
var _progressBar = require("./app/progressBar");
var _wishlist = require("./app/wishlist");
var _search = require("./app/search");
var _cart = require("./app/cart");
var _langSwitcher = require("./app/langSwitcher");
var _postShare = require("./app/postShare");
var _contactBlock = require("./app/blocks/contactBlock");
var _scrollTextBlock = require("./app/blocks/scrollTextBlock");
var header = (0, _stickyHeader.stickyHeader)();
(0, _sldeMenu.slideMenu)(header);
(0, _menuUnderline.menuUnderline)(header);
(0, _postNav.postNav)();
(0, _progressBar.progressBar)();
(0, _wishlist.initWishlistButtons)();
(0, _wishlist.initWishlistCount)();
(0, _search.initSearch)();
(0, _cart.cartInit)();
if (document.cookie.includes('woocommerce_items_in_cart=1')) {
  (0, _cart.syncCartCount)();
}
(0, _langSwitcher.initLangSwitcher)();
(0, _postShare.initPostShare)();
(0, _contactBlock.contactBlock)();
(0, _scrollTextBlock.scrollTextBlock)();

},{"./app/blocks/contactBlock":1,"./app/blocks/scrollTextBlock":2,"./app/cart":3,"./app/langSwitcher":5,"./app/menuUnderline":6,"./app/postNav":7,"./app/postShare":8,"./app/progressBar":9,"./app/search":10,"./app/sldeMenu":11,"./app/stickyHeader":12,"./app/wishlist":14}]},{},[15]);
